const SET_ERROR = 'ERRORS/SET_ERROR'
const REMOVE_ERROR = 'ERRORS/REMOVE_ERROR'
// TODO: add more action types if necessary

export {
  SET_ERROR,
  REMOVE_ERROR,
  // TODO: export action types added later
}
